import { accountingApi } from '../../../../config/apiClient';
import { ACCOUNTING_API } from '../../../../config/api';

// DTO types
export interface InventoryBrandDto {
  id: string;
  companyId: string;
  name: string;
  imageUrl?: string;
  description?: string;
  website?: string;
  createdAt: string;
  updatedAt?: string;
  isActive: boolean;
  isDeleted?: boolean;
  itemCount?: number;
}

export interface CreateInventoryBrandDto {
  companyId: string;
  name: string;
  imageUrl?: string;
  description?: string;
  website?: string;
  isActive: boolean;
}

export interface UpdateInventoryBrandDto {
  companyId: string;
  id: string;
  name: string;
  imageUrl?: string;
  description?: string;
  website?: string;
  isActive: boolean;
}

/**
 * Marka Service - SQL CRUD işlemleri
 */
export class BrandService {
  /**
   * Tüm markaları getir
   */
  static async getAllBrands(companyId: string): Promise<InventoryBrandDto[]> {
    try {
      console.log('🔍 [BRAND SERVICE] Markalar yükleniyor:', companyId);
      const response = await accountingApi.get<InventoryBrandDto[]>(
        ACCOUNTING_API.INVENTORY_BRANDS
      );
      console.log('✅ [BRAND SERVICE] Markalar başarıyla yüklendi:', response.data.length);
      return response.data;
    } catch (error: any) {
      console.error('❌ [BRAND SERVICE] Markalar yüklenirken hata:', error);
      throw new Error(error.response?.data?.message || 'Markalar yüklenirken hata oluştu');
    }
  }

  /**
   * Yeni marka oluştur
   */
  static async createBrand(brand: CreateInventoryBrandDto): Promise<InventoryBrandDto> {
    try {
      console.log('🔍 [BRAND SERVICE] Yeni marka oluşturuluyor:', brand);
      const response = await accountingApi.post<InventoryBrandDto>(
        ACCOUNTING_API.INVENTORY_BRAND_CREATE,
        brand
      );
      console.log('✅ [BRAND SERVICE] Marka başarıyla oluşturuldu:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [BRAND SERVICE] Marka oluşturma hatası:', error);
      throw new Error(error.response?.data?.message || 'Marka oluşturulurken hata oluştu');
    }
  }

  /**
   * Marka güncelle
   */
  static async updateBrand(brand: UpdateInventoryBrandDto): Promise<InventoryBrandDto> {
    try {
      console.log('🔍 [BRAND SERVICE] Marka güncelleniyor:', brand);
      const response = await accountingApi.post<InventoryBrandDto>(
        ACCOUNTING_API.INVENTORY_BRAND_UPDATE(brand.id),
        brand
      );
      console.log('✅ [BRAND SERVICE] Marka başarıyla güncellendi:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [BRAND SERVICE] Marka güncelleme hatası:', error);
      throw new Error(error.response?.data?.message || 'Marka güncellenirken hata oluştu');
    }
  }

  /**
   * Marka sil
   */
  static async deleteBrand(companyId: string, brandId: string): Promise<void> {
    try {
      console.log('🔍 [BRAND SERVICE] Marka siliniyor:', brandId);
      await accountingApi.post(
        ACCOUNTING_API.INVENTORY_BRAND_DELETE(brandId)
      );
      console.log('✅ [BRAND SERVICE] Marka başarıyla silindi');
    } catch (error: any) {
      console.error('❌ [BRAND SERVICE] Marka silme hatası:', error);
      throw new Error(error.response?.data?.message || 'Marka silinirken hata oluştu');
    }
  }
}
